import { connect } from 'react-redux';
import { compose } from 'recompose';
import withNewDesignStyles from '../../../../common/hoc/withNewDesignStyles';
import {
  getItemsProductChart,
  getItemsProductMostSold,
  getProductSalesFees,
  getProductSalesGrossDiscounts,
  getProductSalesGrossProfit,
  getProductSalesGrossRefunds,
  getProductSalesGrossTotal,
  getProductSalesLoanRepayment,
  getProductSalesNetTotal,
  getProductSalesSupplyPrice,
  getProductSalesTaxes,
  getProductSalesTotalCollected,
  getProductSales,
  getProductSalesTaxBreakdown,
} from '../../metrics/selectors';

const SalesByProductContainer = compose(
  withNewDesignStyles,
  connect(
    state => ({
      discounts: getProductSalesGrossDiscounts(state),
      fees: getProductSalesFees(state),
      grossSales: getProductSalesGrossTotal(state),
      products: getItemsProductMostSold(state),
      netSales: getProductSalesNetTotal(state),
      data: getItemsProductChart(state),
      shop: state.auth.shop,
      refunds: getProductSalesGrossRefunds(state),
      taxes: getProductSalesTaxes(state),
      tips: 0,
      totalCollected: getProductSalesTotalCollected(state),
      loanRepayment: getProductSalesLoanRepayment(state),
      grossProfit: getProductSalesGrossProfit(state),
      supplyPrice: getProductSalesSupplyPrice(state),
      productSales: getProductSales(state),
      taxBreakdown: getProductSalesTaxBreakdown(state),
    }),
  ),
);

export default SalesByProductContainer;
